// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:55:37

export default {
  "id": "formula-racing-games-car-game",
  "slug": "formula-racing-games-car-game",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f597ef614f4f42768bf4f566d76021bc-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f597ef614f4f42768bf4f566d76021bc/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Formula Racing Games Car Game",
      "description": "Let's Play and Enjoy car driving in all the Formula Race master 3D tracks of the world and become a champion on all the tracks of the world in the Formula Car Racing Game. Formula Car Stunts Games 3D introduces a new offline car racing game for the fans of the Formula Car simulator. ",
      "instructions": "Use W,A,S,D for player movement.",
      "genres": [
        ".IO",
        "Sports"
      ],
      "tags": [
        "2players",
        "car",
        "speed",
        "speedrun",
        "track"
      ]
    },
    "zh-CN": {
      "title": "公式赛车游戏 赛车游戏",
      "description": "让我们在所有世界级的Formula Race master 3D赛道上享受赛车驾驶，并在Formula Car Racing Game的全球赛道上成为冠军。Formula Car Stunts Games 3D为Formula Car模拟器的粉丝介绍了一款全新的离线赛车游戏。",
      "instructions": "使用W、A、S、D键进行玩家移动。",
      "genres": [
        ".IO",
        "体育"
      ],
      "tags": [
        "2名玩家",
        "汽车",
        "速度",
        "速度跑",
        "赛道"
      ]
    },
    "zh-TW": {
      "title": "公式賽車遊戲 車輛遊戲",
      "description": "讓我們享受在所有公式賽車3D賽道上的駕車遊戲，並成為《公式賽車賽賽》遊戲中所有賽道的冠軍。公式賽車特技遊戲3D為公式賽車模擬器的粉絲介紹一款新的離線賽車遊戲。",
      "instructions": "使用 W、A、S、D 鍵進行角色移動。",
      "genres": [
        ".IO",
        "運動"
      ],
      "tags": [
        "兩人玩家",
        "車輛",
        "速度",
        "速度挑戰賽",
        "賽道"
      ]
    },
    "zh-HK": {
      "title": "公式賽車遊戲 車輛遊戲",
      "description": "讓我們盡情享受在世界各個公式賽車大師3D賽道上的駕駛，成為《公式車賽賽車遊戲》中所有賽道的冠軍。《公式車特技遊戲3D》為公式車模擬器的粉絲們推出一款全新離線賽車遊戲。",
      "instructions": "使用 W,A,S,D 鍵進行玩家移動。",
      "genres": [
        ".IO",
        "體育"
      ],
      "tags": [
        "2玩家",
        "車輛",
        "速度",
        "速度挑戰",
        "賽道"
      ]
    },
    "ja": {
      "title": "フォーミュラレーシングゲーム カーゲーム",
      "description": "世界のすべてのフォーミュラレースマスター3Dトラックで車の運転を楽しみ、フォーミュラカー競走ゲームで世界のすべてのトラックでチャンピオンになろう。フォーミュラカースタンツゲーム3Dは、フォーミュラカーシミュレータのファンのための新しいオフラインカーレースゲームを紹介します。",
      "instructions": "W,A,S,Dを使用してプレイヤーの移動を行ってください。",
      "genres": [
        ".IO",
        "スポーツ"
      ],
      "tags": [
        "2プレイヤー",
        "車",
        "スピード",
        "スピードラン",
        "トラック"
      ]
    },
    "ko": {
      "title": "포맷 레이싱 게임 자동차 게임",
      "description": "세계의 모든 포맷 레이스 마스터 3D 트랙에서 자동차 드라이빙을 즐겨보고, 포맷 카 레이싱 게임에서 세계의 모든 트랙에서 챔피언이 되세요. 포맷 카 스타unts 게임 3D는 포맷 카 시뮬레이터 팬들을 위한 새로운 오프라인 카 레이싱 게임을 소개합니다.",
      "instructions": "W, A, S, D 키를 사용하여 플레이어 이동.",
      "genres": [
        ".아이오",
        "스포츠"
      ],
      "tags": [
        "2players",
        "자동차",
        "속도",
        "스피드런",
        "트랙"
      ]
    },
    "fr": {
      "title": "Courses de Formule Jeu de voitures",
      "description": "Lançons-nous dans les courses de voitures de course en 3D et devenons champions sur toutes les pistes du monde dans le jeu de course automobile de Formule. Formula Car Stunts Games 3D présente un nouveau jeu de course automobile en ligne pour les fans du simulateur de Formule automobile.",
      "instructions": "Utilisez les touches W, A, S, D pour le déplacement du joueur.",
      "genres": [
        ".IO",
        "Sports\n- .IO : .IO\n- Sports : Sports"
      ],
      "tags": [
        "2 joueurs",
        "voiture",
        "vitesse",
        "speedrun",
        "piste"
      ]
    }
  }
};
